/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfGetPrivateNumberSendLimitByIdDto } from '../models/custom-result-of-get-private-number-send-limit-by-id-dto';
import { CustomResultOfPaginatedListOfGetAllPrivateNumberSendLimitWithPaginationDto } from '../models/custom-result-of-paginated-list-of-get-all-private-number-send-limit-with-pagination-dto';
import { CustomResultOfPaginatedListOfGetPrivateNumberSendLimitWithPaginationDto } from '../models/custom-result-of-paginated-list-of-get-private-number-send-limit-with-pagination-dto';
import { privateNumberSendLimitCreateGet } from '../fn/private-number-send-limit/private-number-send-limit-create-get';
import { PrivateNumberSendLimitCreateGet$Params } from '../fn/private-number-send-limit/private-number-send-limit-create-get';
import { privateNumberSendLimitCreatePost } from '../fn/private-number-send-limit/private-number-send-limit-create-post';
import { PrivateNumberSendLimitCreatePost$Params } from '../fn/private-number-send-limit/private-number-send-limit-create-post';
import { privateNumberSendLimitDelete } from '../fn/private-number-send-limit/private-number-send-limit-delete';
import { PrivateNumberSendLimitDelete$Params } from '../fn/private-number-send-limit/private-number-send-limit-delete';
import { privateNumberSendLimitGetAllPrivateNumberSendLimitWithPagination } from '../fn/private-number-send-limit/private-number-send-limit-get-all-private-number-send-limit-with-pagination';
import { PrivateNumberSendLimitGetAllPrivateNumberSendLimitWithPagination$Params } from '../fn/private-number-send-limit/private-number-send-limit-get-all-private-number-send-limit-with-pagination';
import { privateNumberSendLimitGetPrivateNumberSendLimitAuditWithPagination } from '../fn/private-number-send-limit/private-number-send-limit-get-private-number-send-limit-audit-with-pagination';
import { PrivateNumberSendLimitGetPrivateNumberSendLimitAuditWithPagination$Params } from '../fn/private-number-send-limit/private-number-send-limit-get-private-number-send-limit-audit-with-pagination';
import { privateNumberSendLimitGetPrivateNumberSendLimitWithPagination } from '../fn/private-number-send-limit/private-number-send-limit-get-private-number-send-limit-with-pagination';
import { PrivateNumberSendLimitGetPrivateNumberSendLimitWithPagination$Params } from '../fn/private-number-send-limit/private-number-send-limit-get-private-number-send-limit-with-pagination';
import { privateNumberSendLimitUpdateGet } from '../fn/private-number-send-limit/private-number-send-limit-update-get';
import { PrivateNumberSendLimitUpdateGet$Params } from '../fn/private-number-send-limit/private-number-send-limit-update-get';
import { privateNumberSendLimitUpdatePut } from '../fn/private-number-send-limit/private-number-send-limit-update-put';
import { PrivateNumberSendLimitUpdatePut$Params } from '../fn/private-number-send-limit/private-number-send-limit-update-put';

@Injectable({ providedIn: 'root' })
export class PrivateNumberSendLimitService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `privateNumberSendLimitCreateGet()` */
  static readonly PrivateNumberSendLimitCreateGetPath = '/PrivateNumberSendLimit/Create';

  /**
   * Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `privateNumberSendLimitCreateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  privateNumberSendLimitCreateGet$Response(params?: PrivateNumberSendLimitCreateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return privateNumberSendLimitCreateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `privateNumberSendLimitCreateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  privateNumberSendLimitCreateGet(params?: PrivateNumberSendLimitCreateGet$Params, context?: HttpContext): Observable<Blob> {
    return this.privateNumberSendLimitCreateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `privateNumberSendLimitCreatePost()` */
  static readonly PrivateNumberSendLimitCreatePostPath = '/PrivateNumberSendLimit/Create';

  /**
   * Create.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `privateNumberSendLimitCreatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumberSendLimitCreatePost$Response(params: PrivateNumberSendLimitCreatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return privateNumberSendLimitCreatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `privateNumberSendLimitCreatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumberSendLimitCreatePost(params: PrivateNumberSendLimitCreatePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.privateNumberSendLimitCreatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `privateNumberSendLimitUpdateGet()` */
  static readonly PrivateNumberSendLimitUpdateGetPath = '/PrivateNumberSendLimit/Update';

  /**
   * Get By Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `privateNumberSendLimitUpdateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  privateNumberSendLimitUpdateGet$Response(params?: PrivateNumberSendLimitUpdateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetPrivateNumberSendLimitByIdDto>> {
    return privateNumberSendLimitUpdateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get By Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `privateNumberSendLimitUpdateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  privateNumberSendLimitUpdateGet(params?: PrivateNumberSendLimitUpdateGet$Params, context?: HttpContext): Observable<CustomResultOfGetPrivateNumberSendLimitByIdDto> {
    return this.privateNumberSendLimitUpdateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetPrivateNumberSendLimitByIdDto>): CustomResultOfGetPrivateNumberSendLimitByIdDto => r.body)
    );
  }

  /** Path part for operation `privateNumberSendLimitUpdatePut()` */
  static readonly PrivateNumberSendLimitUpdatePutPath = '/PrivateNumberSendLimit/Update';

  /**
   * Update.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `privateNumberSendLimitUpdatePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumberSendLimitUpdatePut$Response(params: PrivateNumberSendLimitUpdatePut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return privateNumberSendLimitUpdatePut(this.http, this.rootUrl, params, context);
  }

  /**
   * Update.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `privateNumberSendLimitUpdatePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumberSendLimitUpdatePut(params: PrivateNumberSendLimitUpdatePut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.privateNumberSendLimitUpdatePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `privateNumberSendLimitDelete()` */
  static readonly PrivateNumberSendLimitDeletePath = '/PrivateNumberSendLimit/Delete';

  /**
   * Delete.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `privateNumberSendLimitDelete()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumberSendLimitDelete$Response(params: PrivateNumberSendLimitDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return privateNumberSendLimitDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `privateNumberSendLimitDelete$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumberSendLimitDelete(params: PrivateNumberSendLimitDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.privateNumberSendLimitDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `privateNumberSendLimitGetPrivateNumberSendLimitWithPagination()` */
  static readonly PrivateNumberSendLimitGetPrivateNumberSendLimitWithPaginationPath = '/PrivateNumberSendLimit/GetPrivateNumberSendLimitWithPagination';

  /**
   * Get With Pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `privateNumberSendLimitGetPrivateNumberSendLimitWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumberSendLimitGetPrivateNumberSendLimitWithPagination$Response(params: PrivateNumberSendLimitGetPrivateNumberSendLimitWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetPrivateNumberSendLimitWithPaginationDto>> {
    return privateNumberSendLimitGetPrivateNumberSendLimitWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get With Pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `privateNumberSendLimitGetPrivateNumberSendLimitWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumberSendLimitGetPrivateNumberSendLimitWithPagination(params: PrivateNumberSendLimitGetPrivateNumberSendLimitWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetPrivateNumberSendLimitWithPaginationDto> {
    return this.privateNumberSendLimitGetPrivateNumberSendLimitWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetPrivateNumberSendLimitWithPaginationDto>): CustomResultOfPaginatedListOfGetPrivateNumberSendLimitWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `privateNumberSendLimitGetAllPrivateNumberSendLimitWithPagination()` */
  static readonly PrivateNumberSendLimitGetAllPrivateNumberSendLimitWithPaginationPath = '/PrivateNumberSendLimit/GetAllPrivateNumberSendLimitWithPagination';

  /**
   * دریافت همه تخصیص خط به کاربر با صفحه بندی (خود و زیرمجموعه).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `privateNumberSendLimitGetAllPrivateNumberSendLimitWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumberSendLimitGetAllPrivateNumberSendLimitWithPagination$Response(params: PrivateNumberSendLimitGetAllPrivateNumberSendLimitWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetAllPrivateNumberSendLimitWithPaginationDto>> {
    return privateNumberSendLimitGetAllPrivateNumberSendLimitWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت همه تخصیص خط به کاربر با صفحه بندی (خود و زیرمجموعه).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `privateNumberSendLimitGetAllPrivateNumberSendLimitWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumberSendLimitGetAllPrivateNumberSendLimitWithPagination(params: PrivateNumberSendLimitGetAllPrivateNumberSendLimitWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetAllPrivateNumberSendLimitWithPaginationDto> {
    return this.privateNumberSendLimitGetAllPrivateNumberSendLimitWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetAllPrivateNumberSendLimitWithPaginationDto>): CustomResultOfPaginatedListOfGetAllPrivateNumberSendLimitWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `privateNumberSendLimitGetPrivateNumberSendLimitAuditWithPagination()` */
  static readonly PrivateNumberSendLimitGetPrivateNumberSendLimitAuditWithPaginationPath = '/PrivateNumberSendLimit/GetPrivateNumberSendLimitAuditWithPagination';

  /**
   * Get Audit With Pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `privateNumberSendLimitGetPrivateNumberSendLimitAuditWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumberSendLimitGetPrivateNumberSendLimitAuditWithPagination$Response(params: PrivateNumberSendLimitGetPrivateNumberSendLimitAuditWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return privateNumberSendLimitGetPrivateNumberSendLimitAuditWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Audit With Pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `privateNumberSendLimitGetPrivateNumberSendLimitAuditWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumberSendLimitGetPrivateNumberSendLimitAuditWithPagination(params: PrivateNumberSendLimitGetPrivateNumberSendLimitAuditWithPagination$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.privateNumberSendLimitGetPrivateNumberSendLimitAuditWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

}
